import { Component } from '@angular/core';
import { environment } from "../../../environments/environment";

@Component({
    selector: 'app-footer',
    templateUrl: 'footer.component.html',
    styleUrls: ['footer.component.css'],
    standalone: false
})
export class FooterComponent {

  appVersion = environment.app_version;

  constructor() {
  }

  scrollToTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }
}
